(function() {
  'use strict';

  angular
    .module('observatoireApp')
    .config(['$stateProvider', routerConfig]);

  function routerConfig($stateProvider) {
    $stateProvider
      .state('main.glossaire', {
        url: '/glossaire',
        templateUrl: 'app/glossaire/glossaire.html',
        controller: 'GlossaireController',
        controllerAs: 'glossaireCtrl'
      });
  }
})();
